export const actionTypes = {
  isAuthenticating: 'USER/AUTHENTICATING',
  authenticated: 'USER/AUTHENTICATED',
  error: 'USER/ERROR',
};
